import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { FormGroupState } from 'ngrx-forms';
import { CanDeactivateBase } from '../guards/can-deactivate.base';
import { Directive } from '@angular/core';

@Directive()
export abstract class FormCanDeactivate extends CanDeactivateBase {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  abstract get form(): FormGroup | Observable<FormGroupState<any>> | undefined;

  canDeactivate(): Observable<boolean> {
    if (this.form === undefined) return of(true);

    const isNotDirty =
      this.form instanceof FormGroup
        ? of(!this.form.dirty)
        : this.form.pipe(
            take(1),
            map(form => !form.isDirty)
          );
    return isNotDirty;
  }
}

@Directive()
export abstract class FormCanDeactivateNoHostListener {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  abstract get form(): FormGroup | Observable<FormGroupState<any>>;
  overrideIsDirtyCanDeactivate: boolean = false;

  canDeactivate(): Observable<boolean> {
    if (this.overrideIsDirtyCanDeactivate) {
      return of(true);
    }

    const isNotDirty =
      this.form instanceof FormGroup
        ? of(!this.form.dirty)
        : this.form.pipe(
            take(1),
            map(form => !form.isDirty)
          );
    return isNotDirty;
  }
}
